import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "brand-page-header__wrapper" }
const _hoisted_2 = { class: "brand-page-header__brand-info" }
const _hoisted_3 = {
  key: 1,
  class: "brand-page__brand-name"
}
const _hoisted_4 = {
  key: 0,
  class: "brand-page-header__description"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "brang-page-header__block" }, null, -1)

import { computed } from 'vue';

import useContext from '@/composables/useContext';
import useLitium from '@/composables/useLitium';

import ImageWithFallback from '../ImageWithFallback.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandPageHeader',
  setup(__props) {

const { page } = useContext();
const { toLitiumMediaUrl } = useLitium();

const brandLogo = computed(() => {
  if (!page.value.imageId) return '';

  return toLitiumMediaUrl(page.value.imageId, { maxHeight: 300 }) || '';
});

const brandName = computed(() => {
  return page.value.name || '';
});

const brandDescription = computed(() => {
  return page.value.description || '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(page).imageId)
          ? (_openBlock(), _createBlock(ImageWithFallback, {
              key: 0,
              image: _unref(brandLogo),
              class: "brand-page-header__brand-logo"
            }, null, 8, ["image"]))
          : _createCommentVNode("", true),
        (_unref(brandName))
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_unref(brandName)), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(brandDescription))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(brandDescription)), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5
  ], 64))
}
}

})